var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 10,
  width: 25,
  height: 17.5,
  rx: 2,
  fill: "#4a5568"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 12,
  width: 21,
  height: 13.5,
  fill: "#eef1fb"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m17.3 25.5c0-3.1 2.3-4.8 5.2-4.8s5.2 1.7 5.2 4.8z",
  fill: "#7c6ff0"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 17.2,
  r: 2.7,
  fill: "#7c6ff0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m19.5 17.2c0-1.7 1.3-3 3-3s3 1.3 3 3",
  fill: "none",
  stroke: "#333a45",
  strokeWidth: 1.1,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 18.9,
  y: 16.6,
  width: 1.3,
  height: 2.2,
  rx: 0.6,
  fill: "#333a45"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 24.8,
  y: 16.6,
  width: 1.3,
  height: 2.2,
  rx: 0.6,
  fill: "#333a45"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m25.4 18.8c0 1.2-1 1.9-2 1.9",
  fill: "none",
  stroke: "#333a45",
  strokeWidth: 0.9,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m9.9 27.5h25.2l2.7 3.7c0.5 0.7 0 1.7-0.9 1.7h-28.8c-0.9 0-1.4-1-0.9-1.7z",
  fill: "#5c6b80"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 19.4,
  y: 28.9,
  width: 6.2,
  height: 1.3,
  rx: 0.65,
  fill: "#8b99ad"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m32.8 3.5h6.8c1.7 0 3 1.3 3 3v3.2c0 1.7-1.3 3-3 3h-4.3l-2.9 2.6 0.4-2.7c-1.5-0.2-3-1.3-3-2.9v-3.2c0-1.7 1.3-3 3-3z",
  fill: "#7c6ff0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m33.9 8.1 1.7 1.7 3.2-3.2",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgRemoteWorkingSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteWorkingSupport);
export default __webpack_public_path__ + "static/media/remote-working-support.e3392e345a6c38005ce0901764472207.svg";
export { ForwardRef as ReactComponent };